import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ListWarrantiesComponent } from "./pages/list-warranties/list-warranties.component";
import { FormComponent } from "./pages/form/form.component";
import { ReportComponent } from "./pages/report/report.component";
import { SearchComponent } from "./pages/search/search.component";
import { SharedModule } from "@app/shared/shared.module";
import { httpInterceptorProviders } from "@app/auth/interceptors";
import { WorkModule } from "@app/work/work.module";

@NgModule({
  declarations: [
    ListWarrantiesComponent,
    FormComponent,
    ReportComponent,
    SearchComponent,
  ],
  imports: [CommonModule, SharedModule, WorkModule],
  exports: [],
  providers: [httpInterceptorProviders],
})
export class WarrantiesModule {}
